import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactDOM from 'react-dom';
import 'react-id-swiper/lib/styles/css/swiper.css';
import ReactModal from 'react-modal';
import { inProduction } from 'shared/helpers/utils';
import App from './App';
import './assets/fonts/font-awesome-4.7.0/css/font-awesome.css';
import './assets/styles/tailwind.css';
import './configureAnalytics';
import { Alert } from './helpers/utils';
import * as serviceWorker from './serviceWorker';
import store, { persistor } from './store';
import { Provider as StoreProvider } from 'react-redux';
import history from './history';
import { Router } from 'react-router-dom';
import Loader from './components/Loader';
import { PersistGate } from 'redux-persist/integration/react';
import ModalProvider from './components/Modal/ModalProvider';
import ErrorBoundary from './components/ErrorBoundary';

ReactModal.setAppElement('#root');

inProduction(() => {
  Sentry.init({
    dsn: 'https://222a5e8dd0bc47da83085cb6b06e4509@sentry.io/1842974'
  });
});

ReactDOM.render(
  <StoreProvider store={store}>
    <PersistGate persistor={persistor} loading={<Loader />}>
      <Router history={history}>
        <ErrorBoundary>
          <ModalProvider>
            <App />
          </ModalProvider>
        </ErrorBoundary>
      </Router>
    </PersistGate>
  </StoreProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  async onUpdate(registration: any) {
    const reload = await new Promise(resolve => {
      const { hide } = Alert.info('Click here to get the latest updates.', {
        hideAfter: 0,
        header: 'New Update Available!',
        onClick: () => {
          resolve(true);
          hide?.();
        }
      });
    });

    if (reload) {
      // We want to run this code only if we detect a new service worker is
      // waiting to be activated.
      // Details about it: https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle
      if (registration && registration.waiting) {
        await registration.unregister();
        // Makes Workbox call skipWaiting()
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        // Once the service worker is unregistered, we can reload the page to let
        // the browser download a fresh copy of our app (invalidating the cache)
        window.location.reload();
      }
    }
  }
});
